import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, SEARCH_TABS_RESULT, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { IBookings } from 'reducers/bookings/models';
import { fetchBookingsData, resetBookingData } from 'actions/bookings';
import { displayFilters } from 'actions/filters';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { searchBookingStatuses } from 'constants/statuses';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { bookingCols } from './models'
import { Search } from '../Search';
import { lastThreeMonthsFilters } from 'utilities/util';
interface IMapDispatchToProps {
    fetchBookingsData: (pageNumber: number, pageSize: number, genericFilter: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetBookingData: () => void;
}
interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    bookings: IBookings | any;
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    showGenericSearch: boolean;
    genericFilter: string;
    page: number;
    pageSize: number;
    totalCount: number;
    clearFilters: boolean;
    isFetchinProgress: boolean;
    pendingError: string | string[];
    dateFrom: boolean,
    etaFrom: boolean,
    etdFrom: boolean,
    typeOfSearch: string,
    booking: any[],
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null
}
export class _SearchBooking extends Component<IProps, IState>{
    public tableRef: any = React.createRef();
    public myInput: any = React.createRef();
    public state = {
        showGenericSearch: true,
        genericFilter: '',
        sorted: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        clearFilters: false,
        dateFrom: false,
        etaFrom: false,
        etdFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.BOOKING,
        booking: [],
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: '',
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        this.props.displayFilters(false, 'jobcostingBooking')
        this.setState({
            isFetchinProgress: false,
        })
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.bookings !== props.bookings) {
            this.setData(this.props.bookings.result, this.props.bookings.page, this.props.bookings.pageSize, this.props.bookings.totalCount)
            this.setState({
                totalCount: this.props.bookings.totalCount
            })
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.state.shouldClear && this.state.shouldClear !== state.shouldClear) {
            this.setState({ genericFilter: '' })
        }
    }

    public componentWillUnmount(){
        this.props.resetSort()
    }
    public render() {
        return (
            <Search triggerFetch={() => this.targetFetch()}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobcostingBooking"
                    requireFilters={true}
                    defaultFilters={lastThreeMonthsFilters('dateFrom', 'dateTo')}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    filters={[
                        <FiltersInput
                            key="bookingNumber"
                            name="bookingNumber"
                            label="Booking number"
                            id={'bookingNumber'}
                        />,
                        <FiltersSelect
                            key="status"
                            name="status"
                            id="status"
                            label="Status"
                            options={[
                                ...searchBookingStatuses
                            ]}
                        />,
                        <FiltersInput
                            key="consigneeBECode"
                            name="consigneeBECode"
                            id="consigneeBECode"
                            label="Consignee (BE Code)"
                        />,
                        <FiltersInput
                            key="shipperBECode"
                            name="shipperBECode"
                            id="shipperBECode"
                            label="Shipper (BE Code)"
                        />,
                        <FiltersDateInput
                            key="dateFrom"
                            name="dateFrom"
                            id="dateFrom"
                            label="Create Date (From)"
                            relatedField="dateTo"
                            type="dateFromTo"
                            setValidity={(val: any) => this.setState({ dateFrom: val })}
                            isInvalid={this.state.dateFrom}
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="dateTo"
                            name="dateTo"
                            id="dateTo"
                            label="Create Date (To)"
                            minValue="dateFrom"
                            setValidity={(val: any) => this.setState({ dateFrom: val })}
                            isInvalid={this.state.dateFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersInput
                            key="portofReceipt"
                            name="portofReceipt"
                            id="portofReceipt"
                            label="Place of Receipt"
                        />,
                        <FiltersInput
                            key="portofLoading"
                            name="portofLoading"
                            id="portofLoading"
                            label="Port of Loading"
                        />,
                        <FiltersInput
                            key="portofDischarge"
                            name="portofDischarge"
                            id="portofDischarge"
                            label="Port of Discharge"
                        />,
                        <FiltersInput
                            key="serviceatOrigin"
                            name="serviceatOrigin"
                            id="serviceatOrigin"
                            label="Origin Service"
                        />,
                        <FiltersInput
                            key="serviceatDestination"
                            name="serviceatDestination"
                            id="serviceatDestination"
                            label="Destination Service"
                        />,
                        <FiltersInput
                            key="placeofDelivery"
                            name="placeofDelivery"
                            id="placeofDelivery"
                            label="Place of Delivery"
                        />
                    ]}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.dateFrom || this.state.etdFrom || this.state.etaFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            booking: [],
                            clearFilters: false,
                            hasData: false
                        })
                    }}
                />
                <TabComponent name="search-results" activeTab={0} navLinks={[SEARCH_TABS_RESULT()[1]]}>
                    <GeneralTable
                        id="jobCosting-search-booking"
                        cols={bookingCols}
                        data={this.state.booking}
                        pageCount={Math.ceil(this.props.bookings.totalCount / this.state.pageSize)}
                        isLoading={this.props.isFetchSearchDataLoading}
                        fetchData={this.justFetch}
                        linkAction={(e: any) => {
                            const getId = e.bookingId ? e.bookingId : e.documentNumber;
                            const url = `/job-costing/booking/${getId}`;
                            this.linkAction(url)
                        }}
                        refFwd={null}
                    />
                </TabComponent>
            </Search>
        );
    }
    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        if (data && data.length) {
            data = data.map((item: any) => {
                if (item.bookingId) {
                    item.id = item.bookingId
                }
                return item;
            });
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            booking: data
        })
    }
    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };
    private resetDates = () => {
        if (this.props.bookings && this.props.bookings.result.length > 0) {
            this.props.resetBookingData()
        }
        this.setState({
            sorted: [],
            page: 1,
            genericFilter: '',
            totalCount: 0,
            dateFrom: false,
            etaFrom: false,
            etdFrom: false,
            isFetchinProgress: true,
            booking: [],
            clearFilters: true,
            shouldClear: false,
            hasData: false,
        })
    };
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-booking') ?
        localStorage.getItem('pageSize-ListTable jobCosting-search-booking') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        }, () => {
            this.props.fetchBookingsData(page, tempPageSize, this.state.genericFilter)
        })
    }
    private fetchReset = (page: number = 1, pageSize: number = 10) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
            this.tableRef.current.querySelector('input[type=number]').value = 1
        }
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize,
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
                isFetchinProgress: true
            });
            this.targetFetch(props.page, props.pageSize)
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.booking.isFetchBookingDataLoading,
    isFetchSearchDataError: state.booking.isFetchBookingDataError,
    searchPendingError: state.booking.bookingDetailsPendingError,
    bookings: state.booking.bookings,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchBookingsData: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(fetchBookingsData(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetBookingData: () => dispatch(resetBookingData())
});
const __SearchB = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchBooking);
export const SearchBooking = withRouter(__SearchB);